<template>
  <v-container fluid>
    <!-- <div id="app">
      <v-app id="inspire">
        <div class="uk-margin">
  <input type="file" accept="image/*" @change="handleUploadFiles">
</div> -->
    <!--Signupg Title-->
    <!-- drug and drop files in v-layout parent of v-file-input -->
    <v-row v-cloak @drop.prevent="addDropFile" @dragover.prevent>
      <v-col cols="8" sm="8">
        <v-file-input
          v-model="files"
          color="deep-purple accent-4"
          counter
          label="File input"
          :placeholder="
            'Select or Drop your ' + this.parentFileCategory + ' files here'
          "
          :hint="this.parentFileType"
          prepend-icon="mdi-paperclip"
          outlined
          persistent-hint
          :show-size="1000"
          :accept="this.parentFileType"
          multiple
        >
          <template v-slot:selection="{ index, text }">
            <v-chip
              v-if="index < 2"
              color="deep-purple accent-4"
              dark
              label
              small
            >
              {{ text }}
            </v-chip>
            <span
              v-else-if="index === 2"
              class="overline grey--text text--darken-3 mx-2"
            >
              +{{ files.length - 2 }} File(s)
            </span>
          </template>
        </v-file-input>
      </v-col>
      <v-col cols="3" sm="3">
        <v-btn
          :loading="loading"
          :disabled="loading"
          color="info"
          type="submit"
          small
          @click.native="handleUploadFiles()"
        >
          <span slot="loader" class="custom-loader">
            <v-icon light>cached</v-icon>
          </span>
          Upload
        </v-btn>
        <!-- <SampleFiles/> -->
      </v-col>
      <v-col cols="4" sm="4">
        <v-snackbar
          v-model="filesSizeSnackBar"
          class="hidden-xs-only"
          color="error"
          :timeout="7000"
          top
        >
          <v-icon class="mr-3">check_cricle</v-icon>
          <h5>
            Files should be zip or xlsx 1mb max size! otherwise we ignore them.
          </h5>
          <v-btn dark text @click="filesSizeSnackBar = false">Close</v-btn>
        </v-snackbar>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
//import SampleFiles from "../shared/sample_files.vue";

export default {
  props: {
    parentFileCategory: {
      type: String,
      default: "FileCategory"
    },
    parentFileType: {
      type: String,
      default: ".???"
    }
  },
  // components: {
  //   SampleFiles
  // },
  data() {
    return {
      files: [],
      filesSizeSnackBar: false
    };
  },

  computed: {
    ...mapGetters(["loading", "error", "clubInfo"])
  },

  watch: {
    files() {
      for (var i = 0; i < this.files.length; i++) {
        if (this.checkFileSize(this.files[i].size)) {
          this.filesSizeSnackBar = true;
        }
      }
    }
  },
  methods: {
    checkFileSize(size) {
      if (size > 1000000) {
        return true;
      }
    },
    addDropFile(e) {
      this.files = Array.from(e.dataTransfer.files);
    },

    handleUploadFiles() {
      /*
    Adds the uploaded file to the files array
  */
      //  this.$store.dispatch("uploadFiles", {
      //    file: this.files
      //  });
      for (var i = 0; i < this.files.length; i++) {
        if (!this.checkFileSize(this.files[i].size)) {
          /* adjust name of incoming file for proper ETL processing */
          Object.defineProperty(this.files[i], "name", {
            writable: true,
            value:
              (this.$route.params.league
                ? "league~" + this.$route.params.league + "~"
                : "") +
              (this.$route.params.club
                ? "club~" + this.$route.params.club + "~"
                : "") +
              this.parentFileCategory +
              "_" +
              this.files[i].name
          });

          this.$store.dispatch("uploadFiles", {
            file: this.files[i]
          });
        }
      }
      this.files = null;
      //}
    }
  },
  mounted() {}
};
</script>
